import type {PromotionCycle} from '../../../../types';

import {LeftOutlined} from '@ant-design/icons';
import {Card} from '@ds/components';

import {formatPromotionDateRange} from '../../../../utils';
import StockAvailability from '../../../common/StockAvailability/StockAvailability';

type LiveDiscountCardProps = {
  cycle: PromotionCycle;
  onClick: () => void;
};

const LiveDiscountCard: React.FC<LiveDiscountCardProps> = ({cycle, onClick}) => {
  const date = formatPromotionDateRange(cycle.discount_start_date, cycle.discount_end_date);

  return (
    <Card
      className="w-full cursor-pointer border-gray-22 shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange [&>div]:p-3"
      size="small"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-3">
          <div className="flex flex-col">
            <div className="flex items-center gap-2.5 text-body-sm-emphasis text-neutral-fg">
              <span className="size-1.5 shrink-0 rounded-full bg-success" aria-hidden />
              <span>{cycle.product_count ?? 0} کالا</span>
            </div>
            <span className="ms-4 text-body-sm text-gray-07">{date}</span>
          </div>
          <LeftOutlined className="text-subtitle-lg text-gray-06" aria-hidden />
        </div>
        <div className="mx-7.5 my-2.5">
          <StockAvailability stockAvailability={cycle.stock_availability} />
        </div>
      </div>
    </Card>
  );
};

export default LiveDiscountCard;
